import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { downloadInvoicePdf } from '../utils/invoicePdf';

const row = { background: '#F4F4F5', borderRadius: 12, padding: '12px 16px', marginBottom: 8, display: 'flex', justifyContent: 'space-between', fontSize: '0.9rem' };
const label = { color: '#71717A' };

export default function PaymentResult() {
  const [params] = useSearchParams();
  const ok = params.get('status') === 'ok';
  const orderId = params.get('order');
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(!!orderId);

  useEffect(() => {
    if (!orderId) return;
    axios.get(`/payment/order/${orderId}`).then(r => {
      setInfo(r.data);
      setLoading(false);
      if (ok && r.data.payment_status === 'paid') toast.success('پرداخت با موفقیت انجام شد.', { position: 'bottom-right', autoClose: 5000, theme: 'colored' });
    }).catch(() => {
      setLoading(false);
      toast.error('دریافت اطلاعات سفارش ممکن نشد.', { position: 'bottom-right', autoClose: 5000, theme: 'colored' });
    });
  }, [orderId]); // eslint-disable-line react-hooks/exhaustive-deps

  const paid = info ? info.payment_status === 'paid' : ok;

  const pdf = () => {
    if (!info) return;
    downloadInvoicePdf({
      orderId: info.id, productName: info.product_name, productCategory: info.product_category,
      basePrice: info.amount, total: info.total ?? info.amount,
      subtotal: info.subtotal ?? info.amount,
      discount: info.discount, discountCode: info.discount_code,
      feePercent: info.fee_percent, fee: info.fee,
      taxPercent: info.tax_percent, tax: info.tax,
      shippingMethod: info.shipping_method, shippingCost: info.shipping_cost, shippingDiscount: info.shipping_discount,
      userName: info.user_name, userEmail: info.user_email, userNationalCode: info.user_national_code,
      userPhone: info.user_phone, userProvince: info.user_province, userCity: info.user_city,
      userAddress: info.user_address, userPostalCode: info.user_postal_code,
      gatewayLabel: info.gateway_label, paymentRef: info.payment_ref || info.authority,
      date: info.paid_at ? new Date(info.paid_at).toLocaleDateString('fa-IR') : undefined,
    });
  };

  return (
    <div style={{ maxWidth: '560px', margin: '60px auto', padding: '0 16px', direction: 'rtl' }}>
      <ToastContainer position="bottom-right" autoClose={5000} rtl={true} theme="colored" />
      <div style={{ padding: '28px 24px', borderRadius: 16, background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.14)', textAlign: 'center' }}>
        {loading ? (
          <div>
            <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#F4F4F5', margin: '0 auto 16px' }} />
            <div style={{ height: 16, borderRadius: 8, background: '#F4F4F5', marginBottom: 10 }} />
            <div style={{ height: 16, borderRadius: 8, background: '#F4F4F5', width: '70%', margin: '0 auto' }} />
          </div>
        ) : (
          <>
            <div style={{ width: 64, height: 64, borderRadius: '50%', background: paid ? '#ECFDF5' : '#FEF2F2', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              {paid
                ? <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                : <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>}
            </div>
            <h2 style={{ fontWeight: 700, fontSize: '1.15rem', margin: '0 0 6px' }}>{paid ? 'پرداخت موفق' : 'پرداخت ناموفق'}</h2>
            <p style={{ color: '#71717A', fontSize: '0.88rem', margin: '0 0 16px' }}>
              {paid ? 'سفارش شما با موفقیت ثبت و پرداخت شد' : 'مبلغی از حساب شما کسر نشده یا بازگردانده می‌شود. می‌توانید دوباره تلاش کنید.'}
            </p>
            {info && (
              <div style={{ textAlign: 'right', marginBottom: 20 }}>
                <div style={row}><span style={label}>شماره پیگیری سفارش</span><b>{info.id}</b></div>
                {(info.payment_ref || info.authority) && (
                  <div style={row}><span style={label}>شماره پیگیری درگاه</span><b style={{ direction: 'ltr' }}>{info.payment_ref || info.authority}</b></div>
                )}
                <div style={row}><span style={label}>وضعیت پرداخت</span><b style={{ color: paid ? '#059669' : '#DC2626' }}>{paid ? 'پرداخت شده' : 'ناموفق'}</b></div>
                {info.gateway_label && <div style={row}><span style={label}>روش پرداخت</span><b>{info.gateway_label}</b></div>}
                <div style={row}><span style={label}>مبلغ پرداخت‌شده</span><b>{Number(info.amount).toLocaleString('fa-IR')} تومان</b></div>
              </div>
            )}
            {!info && orderId && (
              <div style={{ ...row, marginBottom: 20 }}><span style={label}>شماره پیگیری سفارش</span><b>{orderId}</b></div>
            )}
            {paid && info && (
              <button onClick={pdf} style={{ width: '100%', padding: 12, borderRadius: 20, border: 'none', background: '#18181B', color: '#fff', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', fontSize: '0.95rem', boxShadow: '0 2px 4px rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 10 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
                دانلود فاکتور رسمی
              </button>
            )}
            <Link to="/" style={{ display: 'block', padding: 11, borderRadius: 20, border: '1.5px solid #E4E4E7', color: '#18181B', textDecoration: 'none', fontWeight: 700, fontSize: '0.95rem' }}>بازگشت به فروشگاه</Link>
          </>
        )}
      </div>
    </div>
  );
}
